module.exports = __webpack_public_path__ + "static/media/adela-linda-johansson.15e5d6b5.jpg";